/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_Property_A_To_B_TitleInputs */



/**
* | output |
* | --- |
* | "Apply this property from Group A to Group B" |
*
* @param {Compare_Event_Groups_Apply_Property_A_To_B_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_property_a_to_b_title = /** @type {((inputs?: Compare_Event_Groups_Apply_Property_A_To_B_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_Property_A_To_B_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer cette propriété du groupe A au groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenden Sie diese Eigenschaft von Gruppe A auf Gruppe B an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicare questa proprietà dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перенесите это свойство из группы А в группу В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar esta propiedad del Grupo A al Grupo B.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将此特性从A组应用于B组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAのこの特性をグループBに適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह A की इस विशेषता को समूह B पर लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplique esta propriedade do Grupo A ao Grupo B.")
	return /** @type {LocalizedString} */ ("Apply this property from Group A to Group B")
});